import {Typography as AntTypography} from "antd";

export const Typography = AntTypography;
export default Typography;
